export const persistREHYDRATE = 'persist/REHYDRATE'
export const RECOVERY = 'recovery'
export const ACCEPT_INVITE = 'accept'
